import { validator } from "LIB/validate-this";
import { get } from "lodash";
import {
  APPROVAL_STATUS,
  EVALUATION_CHARGE,
  ORIGINAL_EVALUATION,
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_RECEIVED,
  REPAIR_EVALUATION_REJECTED
} from "MODULES/RepairOrders/constants";
import * as rules from "LIB/validation/rules";
import { LABOR_COST, PART_COST } from "MODULES/SalesOrders/constants";
import { TAG_DATE_CONDITIONS } from "MODULES/Receiving/constants";
import {
  CAAC,
  EASA,
  FAA,
  OTHER_TAG_TYPE,
  TAG_DATE,
  TCCA
} from "MODULES/inventories/constants";
import { OTHER } from "MODULES/Lots/constants";

function validateItem(item, values) {
  item.validate(APPROVAL_STATUS).satisfies(rules.required);

  if (
    [REPAIR_EVALUATION_APPROVED, REPAIR_EVALUATION_RECEIVED].includes(
      values.approval_status
    )
  ) {
    item.validate(ORIGINAL_EVALUATION).satisfies(rules.required);
  }

  if (values.approval_status === REPAIR_EVALUATION_APPROVED) {
    item.validate(LABOR_COST, PART_COST).satisfies(rules.requiredAllowZero);
  }

  if (values.approval_status === REPAIR_EVALUATION_REJECTED) {
    item.validate(EVALUATION_CHARGE).satisfies(rules.requiredAllowZero);
  }

  if (TAG_DATE_CONDITIONS.includes(get(values, "inventory.condition"))) {
    item.validate(TAG_DATE).satisfies(rules.required);
  }

  if (values.approval_status === REPAIR_EVALUATION_APPROVED) {
    item
      .validate("Tag Type")
      .satisfies(rules.requiresAtLeast(1, FAA, TCCA, CAAC, EASA, OTHER));
  }

  if (values.other) {
    item
      .validate(OTHER_TAG_TYPE)
      .satisfies(rules.required, rules.maxLengthOfText(30));
  }
}

export default function validate(values) {
  const errors = validator(values, form => {
    form.validateChildren("line_items", validateItem);
  });

  return errors;
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/UpdateEvaluationStatus/validate.js